// TelcoTrack — podíly vlastníků (sdílené shared + authority util).

export function parseShareFraction(
  numerator: number | null | undefined,
  denominator: number | null | undefined,
): number | null {
  if (numerator == null || denominator == null || denominator === 0) return null;
  return numerator / denominator;
}

/** Součet podílů (0–1); null pokud žádný podíl nelze spočítat. */
export function sumOwnerShareFractions(
  shares: Array<{ numerator: number | null; denominator: number | null }>,
): number | null {
  let sum = 0;
  let any = false;
  for (const s of shares) {
    const f = parseShareFraction(s.numerator, s.denominator);
    if (f == null) continue;
    any = true;
    sum += f;
  }
  return any ? sum : null;
}

/** Tolerance pro součet podílů ≈ 1 (zaokrouhlení KN). */
export function ownerSharesSumToOne(
  shares: Array<{ numerator: number | null; denominator: number | null }>,
  epsilon = 0.001,
): boolean {
  const sum = sumOwnerShareFractions(shares);
  if (sum == null) return true; // žádné podíly → nevalidujeme
  return Math.abs(sum - 1) <= epsilon;
}
